import Select, { createFilter } from 'react-select'
import {
  filterNewApprovalPhotos,
  filterNewGalleryPhotos,
  getObjectFromValue,
  getValueFromObject
} from '../Functions'
import update from 'immutability-helper'
import { handlePushHistory } from '../PhotoSearch/Functions'
import Categories from '../Components/PhotoOptions/CategoryOptions'
import React from 'react'

const CategoriesSearch = ({
  setState,
  state,
  varNames
}) => {
  const {
    [`${varNames.category}`]: category
  } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-categories'>
      <Select
        isClearable
        className='photos-search-container'
        onChange={(category) => {
          const newImageCategory = getValueFromObject(category)
          console.log('Changing Category: ', newImageCategory)

          callbacks[`${varNames.callback}`]({
            state: update(state, {
              [`${varNames.academyTimeframe}`]: { $set: '' },
              [`${varNames.category}`]: { $set: (newImageCategory || '') },
              [`${varNames.decade}`]: { $set: '' },
              [`${varNames.service}`]: { $set: '' },
              [`${varNames.serviceBranch}`]: { $set: '' },
              [`${varNames.subsection}`]: { $set: '' },
              [`${varNames.year}`]: { $set: '' }
            }),
            setState: (state) => setState(state),
            varNames
          })

          handlePushHistory({ category, state })
          console.log('History State: ', window.history.state)
        }}
        options={Categories}
        placeholder='Select a category...'
        value={getObjectFromValue(category, Categories)}
        filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
      />
    </div>
  )
}

export default CategoriesSearch
